<template><svg
        viewBox="0 0 27 26"
        xmlns="http://www.w3.org/2000/svg"
>
    <g>
        <path d="M16.7383 4.75C16.0591 4.75 15.5078 4.302 15.5078 3.75V2.25H10.5859V3.75C10.5859 4.302 10.0347 4.75 9.35547 4.75C8.67625 4.75 8.125 4.302 8.125 3.75V2.25C8.125 1.147 9.22873 0.25 10.5859 0.25H15.5078C16.865 0.25 17.9688 1.147 17.9688 2.25V3.75C17.9688 4.302 17.4175 4.75 16.7383 4.75Z"/>
        <path d="M14.1516 17.1402C13.9547 17.2312 13.6703 17.2962 13.375 17.2962C13.0797 17.2962 12.7953 17.2312 12.5328 17.1142L0.25 12.25V22.1734C0.25 24.1503 1.59531 25.75 3.25781 25.75H23.4922C25.1547 25.75 26.5 24.1503 26.5 22.1734V12.25L14.1516 17.1402Z"/>
        <path d="M26.5 7.66667V10.72L13.6375 15.9467C13.55 15.9867 13.4625 16 13.375 16C13.2875 16 13.2 15.9867 13.1125 15.9467L0.25 10.72V7.66667C0.25 5.64 1.59531 4 3.25781 4H23.4922C25.1547 4 26.5 5.64 26.5 7.66667Z"/>
    </g>
</svg>
</template>